import { useEffect } from "react";
import SiteNav from "../components/SiteNav";
import SiteFooter from "../components/SiteFooter";
import "../pages/LandingPage.css"; // Reusing existing landing styles

export default function CapacityReachedPage() {
  const SUPPORT_INVITE = "https://discord.gg/WAgvT7QxWx";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-page">
      {/* Hide the CTA in nav since we are on the capacity page */}
      <SiteNav showCta={false} />

      <main className="landing-hero" style={{ minHeight: "60vh", display: "flex", flexDirection: "column", justifyContent: "center", textAlign: "center" }}>

        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          {/* Yellow/Amber Badge for Status */}
          <div className="landing-hero-badge" style={{ color: "#f59e0b", borderColor: "rgba(245, 158, 11, 0.3)", background: "rgba(245, 158, 11, 0.1)" }}>
            <svg width={16} height={16} fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
            </svg>
            Status: Paused
          </div>

          <h1 className="landing-hero-title">
            New Invites are <span className="landing-hero-gradient">Momentarily Paused</span>
          </h1>
          <p className="landing-hero-description">
            Due to high demand, we have momentarily paused new invites to ensure stability for current users. We will reopen invites very soon.
          </p>

          <p className="landing-hero-description" style={{ fontSize: "1rem", marginTop: "-1rem" }}>
            Join our community server to get notified the moment invites reopen.
          </p>

          <div className="landing-hero-buttons" style={{ justifyContent: "center" }}>
            <a
              href={SUPPORT_INVITE}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-hero"
              style={{ textDecoration: "none" }}
            >
              <svg width={20} height={20} fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z" />
              </svg>
              Join Our Discord
            </a>
          </div>

          <div style={{ marginTop: "2rem", color: "var(--text-muted)", fontSize: "0.9rem" }}>
            Already have the bot? <a href="/dashboard" style={{ color: "var(--accent)" }}>Go to Dashboard</a>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}
